import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "play",
  "use": "play-usage",
  "viewBox": "0 0 26 26",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 26 26\" id=\"play\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13 24c6.075 0 11-4.925 11-11S19.075 2 13 2 2 6.925 2 13s4.925 11 11 11zm0 2c7.18 0 13-5.82 13-13S20.18 0 13 0 0 5.82 0 13s5.82 13 13 13z\" /><path d=\"M10.833 9.1v7.8L16.9 13l-6.067-3.9z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol